import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import "./ModalOrder.css";

function ModalOrder({ item }) {
  const [show, setShow] = useState(false);

  const [userData, setUserData] = useState({
    name: "",
    email: "",
    address: "",
    zip: "",
    mobile: "",
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault(); // 🔹 منع ريفريش الصفحة

    const orderData = {
      ...userData,
      item: item?.Title || "Unknown Item",
      price: item?.price || "N/A",
      date: new Date().toLocaleString(),
    };

    // 🔹 حفظ الطلب في localStorage
    const existingOrders = JSON.parse(localStorage.getItem("orders")) || [];
    existingOrders.push(orderData);
    localStorage.setItem("orders", JSON.stringify(existingOrders));

    alert("✅ تم حفظ الطلب بنجاح!");
    handleClose();

    // 🔹 إعادة تعيين القيم
    setUserData({
      name: "",
      email: "",
      address: "",
      zip: "",
      mobile: "",
    });
  };

  return (
    <>
      <button className="btn" onClick={handleShow}>
        Order Now
        <i className="bi bi-basket2-fill ms-2"></i>
      </button>

      <Modal className="main" show={show} onHide={handleClose}>
        <Modal.Header className="header" closeButton>
          <Modal.Title className="titleModal mb-3 mx-auto">
            Make Your Order Now!
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form className="main-modal" onSubmit={handleSave}>
            <input
              type="text"
              name="name"
              placeholder="Your name"
              value={userData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={userData.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="address"
              placeholder="Your Address"
              value={userData.address}
              onChange={handleChange}
              required
            />

            <div className="info">
              <input
                type="number"
                name="zip"
                placeholder="Zip Code"
                value={userData.zip}
                onChange={handleChange}
                required
              />
              <input
                type="number"
                name="mobile"
                placeholder="Mobile No."
                value={userData.mobile}
                onChange={handleChange}
                required
              />
            </div>

            <Form.Select className="my-3 dropItems">
              <option>
                {item?.Title} - {item?.price}
              </option>
            </Form.Select>

            <div className="footer text-center mt-3">
              <Button type="submit">
                Send Message
                <i className="bi bi-send ms-2"></i>
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalOrder;
